<template>
  <aside class="sidebar">
    <button class="toggle-nav" @click="toggleNav()">
      <font-awesome-icon icon="angle-right" fixed-width class="closed"/>
      <font-awesome-icon icon="angle-left" fixed-width class="open"/>
      <span class="sr-only sr-only-focusable">Menu</span>
    </button>
    <div class="sidebar-inner">
      <div class="brand d-flex align-items-center">
        <img
          src="/static/als-logo.png"
          class="img-fluid main-logo"
          alt="ALS Ltd"
        >
      </div>
      <ClientSelection
        :selected-clients="selectedClients"
        :clients="clients"
        @cschange="clientSelectionChanged"
      />
      <nav class="primary-nav">
        <router-link tag="a" to="/overview" exact>
          <font-awesome-icon icon="th" size="lg" fixed-width class="icon"/>Overview
        </router-link>
        <router-link tag="a" to="/jobs">
          <font-awesome-icon icon="clipboard" size="lg" fixed-width class="icon"/>Jobs
        </router-link>
        <router-link tag="a" to="/samples">
          <font-awesome-icon icon="vials" size="lg" fixed-width class="icon"/>Samples
        </router-link>
        <router-link tag="a" to="/results">
          <font-awesome-icon icon="chart-pie" size="lg" fixed-width class="icon"/>Results
        </router-link>
        <router-link tag="a" to="/users" v-if="hasAdminAccess()">
          <font-awesome-icon icon="users" size="lg" fixed-width class="icon"/>Users
        </router-link>
        <router-link tag="a" to="/settings">
          <font-awesome-icon icon="sliders-h" size="lg" fixed-width class="icon"/>Settings
        </router-link>
        <router-link tag="a" to="/contact" exact>
          <font-awesome-icon icon="envelope" size="lg" fixed-width class="icon"/>Contact
        </router-link>
        <router-link tag="a" to="/logout" exact>
          <font-awesome-icon icon="lock" size="lg" fixed-width class="icon"/>Logout
        </router-link>
      </nav>
    </div>
  </aside>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";

.sidebar {
  background-color: $brand-gray;
  bottom: 0;
  position: fixed;
  top: 0;
  -webkit-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 200px;
  z-index: 1000;

  .toggle-nav {
    position: absolute;
    left: 100%;
    top: 16px;
    z-index: 9999;
    background: $brand-gray;
    padding: 15px 5px;
    border-radius: 0px 3px 3px 0px;
    border: none;
    color: #fff;
    display: none;
    .open {
      display: none;
    }
    .closed {
      display: block;
    }
  }

  &.reveal {
    left: 0px;
    .toggle-nav {
      .open {
        display: block;
      }
      .closed {
        display: none;
      }
    }
  }

  .sidebar-inner {
    position: relative;
    height: 100%;
    overflow-y: auto;

    .brand {
      padding: 10px 20px;
      height: 80px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      .main-logo {
        display: block;
        max-height: 100%;
        width: auto;
      }
    }
    .primary-nav {
      padding-bottom: 50px;
      a {
        position: relative;
        color: rgba(255, 255, 255, 0.6);
        text-align: left;
        display: block;
        font-size: 1rem;
        letter-spacing: 0.5pt;
        padding: 10px 20px;
        transition: all 200ms;
        .icon {
          display: inline-block;
          text-align: left;
          margin: 0 15px 0px 0px;
          font-size: 1.2rem;
          color: rgba(255, 255, 255, 0.3);
        }

        &::before {
          content: "";
          width: 0px;
          height: 100%;
          background-color: rgba(255, 255, 255, 0.1);
          position: absolute;
          left: 0;
          top: 0;
          transition: background-color 400ms;
        }

        &:hover {
          text-decoration: none;
          color: #fff;
          opacity: 1;
          .icon {
            color: #fff;
          }
          &::before {
            width: 100%;
            background: rgba(255, 255, 255, 0.05);
            transition: none;
          }
        }
        &.active {
          text-decoration: none;
          color: #fff;
          background: rgba(#000, 0.1);
          .icon {
            color: #fff;
          }
          &::before {
            width: 3px;
            background: $brand-primary;
          }
        }
      }
    }
  }
}

// Responsive Overrides
@media (max-width: 1280px) {
  .sidebar {
    left: -200px;
    width: 200px;

    .toggle-nav {
      display: block;
    }
  }
}
</style>

<script>
import ClientSelection from "@/components/ClientSelection.vue";
import {
  getCurrentUser,
  hasAdminRole,
  hasApiAccess
} from "@/services/usersession";

export default {
  name: "PortalSidebar",
  components: { ClientSelection },
  props: {
    selectedClients: {
      type: Array,
      default: () => []
    },
    clients: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    hasAdminAccess() {
      return hasAdminRole(this.$session);
    },
    hasApiAccess() {
      return hasApiAccess(this.$session);
    },
    toggleNav() {
      const sidebar = document.querySelector(".sidebar");
      sidebar.classList.toggle("reveal");
    },
    clientSelectionChanged(data) {
      // pass it up
      this.$emit("cschange", data);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/PortalSidebar.vue